import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AnotherBrandDescription, Brand } from 'src/typings';
import { AddAnotherDescriptionComponent } from '../add-another-description/add-another-description.component';
import { BrandService } from '../brand.service';

@Component({
  selector: 'app-description-list',
  templateUrl: './description-list.component.html',
  styleUrls: ['./description-list.component.scss']
})
export class DescriptionListComponent {
  @Input() set brand(value: Brand | undefined) {
    if (!value) return;
    this._brand = value;
    if (value.another_descriptions) this.descriptions = value.another_descriptions;
  }

  loading = false;

  @Output() brandChanged = new EventEmitter<Brand>();

  get brand() {
    return this._brand;
  }

  private _brand: Brand | undefined;

  descriptions: AnotherBrandDescription[] = [];

  columnsToDisplay = ['description', 'menu'];

  constructor(private dialog: MatDialog, private brandService: BrandService) {}

  openDescriptionDialog() {
    const dialogRef = this.dialog.open(AddAnotherDescriptionComponent, {
      width: '680px',
      maxWidth: 'calc(100vw - 32px)',
      autoFocus: false
    });
    dialogRef.componentInstance.brand = this.brand;
    dialogRef.componentInstance.doneEvent.subscribe(async () => {
      if (!this.brand) return;
      this.brand = await this.brandService.getOne(this.brand.id).toPromise();
      if (this.brand) {
        this.brandChanged.emit(this.brand);
      }
      dialogRef.close();
    });
  }

  async deleteDescription(payload: AnotherBrandDescription) {
    if (!this.brand) return window.alert('Нет производителя!');
    this.loading = true;
    try {
      await this.brandService.removeAnotherBrandDescription(payload.id).toPromise();
      this.brand = await this.brandService.getOne(this.brand.id).toPromise();
      if (this.brand) {
        this.brandChanged.emit(this.brand);
      }
      this.loading = false;
    } catch (err) {
      console.error(err);
      this.loading = false;
    }
  }
}
